<div>
  <h4 (click)="showTasks = !showTasks"
      class="task-section-header">
    <span class="section-title">{{groupTitle}}</span>
    <span class="text-light task-counts">({{taskCounts(tasks)}}
      @if (tasks.importantLength && taskPriorityDueTimeEnabled) {
        <mat-icon small
                  color="warn">
          priority_high
        </mat-icon>
      })
    </span>
    <mat-icon [@iconSwap]="showTasks"
              class="expand-more">expand_more</mat-icon>
  </h4>
  @if (showTasks) {
    <ul>
      @for (task of tasks; track task) {
        <li title="Modify this task"
            (click)="showTaskDetails(task)"
            [ngClass]="{'priority-task': task.isHighPriority && taskPriorityDueTimeEnabled, 'checklist': task.checklistSummary}">
          @if (taskPriorityDueTimeEnabled && task.isHighPriority) {
            <div class="activity-icon important-task">
              <mat-icon>priority_high</mat-icon>
            </div>
          }
          @if (taskContext !== 'Applicant') {
            <a (click)="$event.stopPropagation(); goToAccount(task.applicantId)"
               title="View this applicant">{{ task.applicantName + " - " }}</a>
          }
          <p class="task-description">
            {{task.taskDescription | slice:0:task.taskCharLimit}}@if (task.taskDescription.length > taskDescriptionLimit) {
              <a title="This task was partially hidden. Click here to show / hide the full task."
                 (click)="$event.stopPropagation(); toggleTaskDescription(task)">
                {{task.taskDescription.length > task.taskCharLimit ? '... show more' : ' show less'}}
              </a>
            }
          </p>
          <div class="task-footer">
            <small>
              <span title="Task created by">By {{task.createdByName}}</span>
              <span [ngClass]="{'text-error': task.isOverDue}"
                    title="Task due date">
                {{ task.dueDate | taskDueDateTime: taskPriorityDueTimeEnabled }}
              </span>
              @if (!task.taskAssignment.userId) {
                <span title="Task is assigned to this {{task.taskAssignment.userId ? 'user' : 'department' }}"
                      class="assignee">
                  <i class="icon-persons icon-large"></i> {{task.taskAssignment.name}}
                </span>
              }
            </small>
          </div>
          @if (task.checklistSummary) {
            <mat-progress-bar class="checklist-progress"
                              mode="determinate"
                              [value]="(task.checklistSummary.completedCount/task.checklistSummary.totalCount)*100" />
            <small class="checklist-count">
              {{task.checklistSummary.completedCount}}/{{task.checklistSummary.totalCount}} completed
            </small>
          }
        </li>
        }
    </ul>
    }
</div>